import React from "react";
import { Box, Skeleton } from "@mui/material";

// Renders a handful of pulsing skeleton rows shaped like a real DataGrid's
// header + body — used while the first page of a table is loading, so org
// owners see the table's actual structure (same column widths, same row
// height) rather than a generic spinner. `columns` mirrors each column's
// DataGrid sizing (`flex` or `width`) so widths line up once real rows
// replace the skeleton.
const TableRowsSkeleton = ({ columns, rowCount = 3, rowHeight = 55 }) => (
  <Box sx={{ border: "1px solid #e0e0e0", borderRadius: "4px", overflow: "hidden" }}>
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#f6f6f6",
        borderBottom: "1px solid #e0e0e0",
        height: "45px",
        alignItems: "center",
        px: 1,
      }}
    >
      {columns.map((col, i) => (
        <Box
          key={col.field ?? i}
          sx={{
            flex: col.flex ?? "none",
            width: col.width ? `${col.width}px` : undefined,
            minWidth: col.minWidth ?? "auto",
            px: 1,
          }}
        >
          <Skeleton variant="text" width="60%" height={20} animation="wave" />
        </Box>
      ))}
    </Box>
    {Array.from({ length: rowCount }).map((_, rowIdx) => (
      <Box
        key={rowIdx}
        sx={{
          display: "flex",
          alignItems: "center",
          height: `${rowHeight}px`,
          px: 1,
          borderBottom: rowIdx < rowCount - 1 ? "0.5px solid #d4d4d4" : "none",
        }}
      >
        {columns.map((col, colIdx) => (
          <Box
            key={col.field ?? colIdx}
            sx={{
              flex: col.flex ?? "none",
              width: col.width ? `${col.width}px` : undefined,
              minWidth: col.minWidth ?? "auto",
              px: 1,
              display: "flex",
              justifyContent: col.align === "center" ? "center" : "flex-start",
            }}
          >
            <Skeleton
              variant="text"
              width={`${55 + ((rowIdx * 7 + colIdx * 13) % 30)}%`}
              height={22}
              animation="wave"
            />
          </Box>
        ))}
      </Box>
    ))}
  </Box>
);

export default TableRowsSkeleton;
